const measurementId = () => process.env.REACT_APP_MEASUREMENT_ID;

const analyticsEnabled = () =>
  process.env.NODE_ENV !== "test" && Boolean(measurementId());

const GA_DESCRIPTION_LIMIT = 100;

const send = (callback) => {
  try {
    callback();
  } catch (e) {
    return;
  }
};

export const pageview = (path) => {
  if (!analyticsEnabled() || typeof window.gtag !== "function" || !path) {
    return;
  }
  send(() => {
    window.gtag("config", measurementId(), { page_path: path });
  });
};

const clip = (value) => String(value || "").slice(0, GA_DESCRIPTION_LIMIT);

export const reportException = (details) => {
  if (!analyticsEnabled() || typeof window.gtag !== "function") {
    return;
  }
  const fields =
    typeof details === "string" ? { description: details } : details || {};
  const params = { fatal: false };
  const description = clip(fields.description);
  if (description) {
    params.description = description;
  }
  const errorMessage = clip(fields.errorMessage);
  if (errorMessage) {
    params.error_message = errorMessage;
  }
  const errorCode = clip(fields.errorCode);
  if (errorCode) {
    params.error_code = errorCode;
  }
  const context = clip(fields.context);
  if (context) {
    params.context = context;
  }
  const pagePath = clip(fields.pagePath);
  if (pagePath) {
    params.page_path = pagePath;
  }
  if (!params.description && !params.error_message && !params.error_code) {
    return;
  }
  send(() => {
    window.gtag("event", "exception", params);
  });
};

const clickLabel = (target) => {
  const label =
    target.getAttribute("aria-label") || target.innerText || target.textContent || "";
  return label.replace(/\s+/g, " ").trim().slice(0, GA_DESCRIPTION_LIMIT);
};

const onDocumentClick = (event) => {
  if (!analyticsEnabled() || typeof window.gtag !== "function") {
    return;
  }
  const element =
    event.target instanceof Element
      ? event.target
      : event.target?.parentElement;
  const target = element?.closest("button, a, [role='button']");
  if (!target) {
    return;
  }
  const label = clickLabel(target);
  const params = { page_path: window.location.pathname };
  if (label) {
    params.link_text = label;
  }
  send(() => {
    window.gtag("event", "click", params);
  });
};

let stopClickTracking = null;

export const trackClicks = () => {
  if (!analyticsEnabled() || stopClickTracking) {
    return stopClickTracking || (() => {});
  }
  document.addEventListener("click", onDocumentClick);
  stopClickTracking = () => {
    document.removeEventListener("click", onDocumentClick);
    stopClickTracking = null;
  };
  return stopClickTracking;
};

export const trackRouter = (router) => {
  let lastPath;
  const track = () => {
    const path = router.state.location.pathname;
    if (!path || path === lastPath) {
      return;
    }
    lastPath = path;
    pageview(path);
  };
  track();
  return router.subscribe(track);
};
